/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Archive_Load_MoreInputs */

const en_newsletter_archive_load_more = /** @type {(inputs: Newsletter_Archive_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show older issues`)
};

/**
* | output |
* | --- |
* | "Show older issues" |
*
* @param {Newsletter_Archive_Load_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_archive_load_more = /** @type {((inputs?: Newsletter_Archive_Load_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Archive_Load_MoreInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_archive_load_more(inputs)
});